import { SVGS } from '@zonofi/zono-money-design-system';
import React from 'react';
import './cart-icon.scss';
import { getIsOrderTaskEnabled } from '@zonofi/zono-money-store';
import { useAppSelector } from '@zonofi/zono-money-helpers';
interface CartIconProps {
  onCartClick: () => void;
  itemsCount: number;
}
export const CartIcon: React.FC<CartIconProps> = ({
  onCartClick,
  itemsCount,
}) => {
  const isOrderTaskEnabled = useAppSelector(getIsOrderTaskEnabled);

  if (!isOrderTaskEnabled) return null;

  return (
    <div className="cart-icon-container" onClick={onCartClick}>
      <img className="cart-icon-container-image" src={SVGS.Cart} alt="" />
      {itemsCount > 0 && (
        <span className="cart-icon-container-badge font-primary-semibold">
          {itemsCount}
        </span>
      )}
    </div>
  );
};
